

export class DtoBase {
public id!:number;
public descripcion!:string
}



